import { render, staticRenderFns } from "./GDPRModal.vue?vue&type=template&id=7e1bd6da&"
import script from "./GDPRModal.vue?vue&type=script&lang=js&"
export * from "./GDPRModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports